/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductFormulationDetailsDto = {
    id?: string;
    readonly formulation?: string;
    readonly formulationState?: ProductFormulationDetailsDto.formulationState;
    readonly active?: boolean;
};
export namespace ProductFormulationDetailsDto {
    export enum formulationState {
        NEW = 'NEW',
        REQUESTED = 'REQUESTED',
        APPROVED = 'APPROVED',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        EXPIRED = 'EXPIRED',
        INACTIVE = 'INACTIVE',
        ANNUAL_REPORT_DUE = 'ANNUAL_REPORT_DUE',
        ANNUAL_REPORT_NOT_EXTENDED = 'ANNUAL_REPORT_NOT_EXTENDED',
        ANNUAL_REPORT_OVERDUE = 'ANNUAL_REPORT_OVERDUE',
        RENEWAL_REQUIRED = 'RENEWAL_REQUIRED',
        RENEWAL_APPROVAL_REQUIRED = 'RENEWAL_APPROVAL_REQUIRED',
        RENEWAL_APPROVAL_REQUESTED = 'RENEWAL_APPROVAL_REQUESTED',
        REWORK_NECESSARY = 'REWORK_NECESSARY',
    }
}

